import React from 'react';
import { useSelector } from 'react-redux';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ enableWayfinder }) => enableWayfinder ? `
    margin-top: 200px;

    // wide screens - landscape mode
    @media (min-width: 1920px) {
      margin-top: 0;
      position: fixed;
      left: 50%;
      right: 0;
      top: 0;
      bottom: 0;
    }
  ` : `
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  `}
`;

const Svg = styled.svg`
  animation: ${rotate} 2s linear infinite;
  width: 40px;
  height: 40px;
`;

const Circle = styled.circle`
  stroke: ${props => props.theme.headerColor};
  stroke-linecap: round;
  animation: ${dash} 1.5s ease-in-out infinite;
`;

const FullScreenLoader = () => {
  const enableWayfinder = useSelector(state => state.configuration.hubSettings.enableWayfinder);
  return (
    <LoaderWrapper enableWayfinder={enableWayfinder}>
      <Svg viewBox="0 0 50 50">
        <Circle cx="25" cy="25" r="20" fill="none" strokeWidth="4" />
      </Svg>
    </LoaderWrapper>
  );
};

export default FullScreenLoader;